import { Injectable } from '@angular/core';
import { OnFinish } from 'src/app/rokezzz/api/api/on-finish';
import { Credentials } from '../api/credentials';
import { Auth } from '../api/auth';
import { HttpErrorResponse } from '@angular/common/http';
import { RokezzzRecaptchaService } from 'src/app/rokezzz/recaptcha/services/recaptcha.service';
import { RokezzzApiService } from '../../api/services/api.service';
import { RokezzzLoginStatusService } from './login-status.service';

@Injectable({
    providedIn: 'root'
})
export class RokezzzAuthService {
    public readonly apiPath: string = 'auths';

    public constructor(
        protected readonly rokezzzApiService: RokezzzApiService,
        protected readonly rokezzzRecaptchaService: RokezzzRecaptchaService,
        protected readonly rokezzzLoginStatusService: RokezzzLoginStatusService
    ) { }

    public getIRI(id: number): string {
        return this.rokezzzApiService.apiUrl + this.apiPath + '/' + id;
    }

    public post(
        data: Credentials,
        onSuccess: OnFinish<Auth>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzRecaptchaService.prepareTokenForAction(
            'postAuth',
            (): void => {
                this.rokezzzApiService.post(
                    this.apiPath,
                    data,
                    (auth: Auth): void => {
                        this.rokezzzLoginStatusService.setLoginStatus(Boolean(auth.token));

                        return onSuccess(auth);
                    },
                    onError
                );
            }
        );
    }

    public delete(
        onSuccess: OnFinish<void>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.delete(
            this.apiPath + '/loggedUser',
            {},
            onSuccess,
            onError
        );
    }

    public ping(
        onSuccess: OnFinish<Auth>,
        onError: OnFinish<HttpErrorResponse>
    ): void {
        this.rokezzzApiService.patch(
            this.apiPath + '/ping',
            {},
            (auth: Auth): void => {
                this.rokezzzLoginStatusService.setLoginStatus(true);

                return onSuccess(auth);
            },
            (error: HttpErrorResponse): void => {
                this.rokezzzLoginStatusService.setLoginStatus(false);

                return onError(error);
            }
        );
    }
}
